import { useQuery } from "@tanstack/react-query";
import lensService from "../../../services/lensService";

const useRuns = () =>
    useQuery({
        queryKey: ["lens", "runs"],
        queryFn: lensService.fetchRuns,
        refetchInterval: (query) => (query.state.data?.some((run) => run.status === "running") ? 5000 : false),
    });

export default useRuns;
